export const MediaType = {
  AUDIO: 'music',
  VIDEO: 'video',
  IMAGE: 'picture',
  SECURE_IMAGE: 'secure_picture',
  DOCUMENT: 'document',
  STATIC: 'static_file',
  ARCHIVE: 'archive',
};
export const getMediaFileType = (fileType: string) => {
  const imageExtensions = [
    'jpg',
    'png',
    'gif',
    'jpeg',
    'jpe',
    'jfif',
    'bmp',
    'heic',
    'heif',
    'tiff',
    'tif',
    'webp',
  ];
  const videoExtensions = [
    'avi',
    'mpeg',
    'mpg',
    'mpe',
    'mp4',
    'mkv',
    'webm',
    'mov',
    'ogv',
    'vob',
    'm4v',
    '3gp',
    'divx',
    'xvid',
    'mxf',
    'wmv',
    'm1v',
    'flv',
    'm2ts',
  ];
  const audioExtensions = [
    'mp3',
    'wav',
    'flac',
    'm4a',
    'wma',
    'aac',
    'aif',
    'aiff',
  ];
  const archiveExtensions = [
    'zip',
    'rar',
    'tar',
    'gz',
    'gzip',
    'jar',
    '7z',
    'fgz',
    'webarchive',
  ];
  const type = `${fileType}`.toLowerCase();

  if (imageExtensions.includes(type)) {
    return MediaType.IMAGE;
  }
  if (videoExtensions.includes(type)) {
    return MediaType.VIDEO;
  }
  if (audioExtensions.includes(type)) {
    return MediaType.AUDIO;
  }
  if (archiveExtensions.includes(type)) {
    return MediaType.ARCHIVE;
  }
  return MediaType.DOCUMENT;
};

export const getDomain = (mediaType: string, metaSiteId: string) => {
  if (!metaSiteId) {
    throw new Error('metaSiteId is required to resolve file domain');
  }
  return (
    {
      picture: 'static.wixstatic.com',
      video: 'video.wixstatic.com',
      music: 'music.wixstatic.com',
      document: `${metaSiteId}.usrfiles.com`,
      archive: `${metaSiteId}.usrfiles.com`,
    }[mediaType] ?? `${metaSiteId}.usrfiles.com`
  );
};
